import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="announcement-choice"
// Radios that reveal fields for one value ("only these" targeting, a set period) and hide them
// otherwise; hidden checkboxes are unchecked so the criterion no longer filters.
export default class extends Controller {
  static targets = ['values'];
  static values = { reveal: { type: String, default: 'some' } };

  toggle(event) {
    const revealed = event.target.value === this.revealValue;
    this.valuesTarget.classList.toggle('d-none', !revealed);
    if (revealed) return;

    this.valuesTarget.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => { checkbox.checked = false; });
  }
}
